import { AxiosResponse } from "axios";
import { FiltroGeneracionSIIIndividual, FiltroGeneracionSIIMasivo } from "../models/filtroGeneracionSII";
import axiosInstance from "../../../../interceptors/axiosInstance";
import { FileEndosoDto } from "../../../endosos/generacionmasiva/models/fileEndosoDto";

const generarCertificadosSIIIndividual = async (e: FiltroGeneracionSIIIndividual) : Promise<AxiosResponse<FileEndosoDto>> => {
    const response = await axiosInstance.post(`siscred-api-reportes/v1/certificado-sii/generar-individual`, e);
    return response;
}

const generarCertificadosSIIMasivo = async (e: FiltroGeneracionSIIMasivo) : Promise<AxiosResponse> => {
    const response = await axiosInstance.post(`siscred-api-reportes/v1/certificado-sii/generar-masivo`, e);
    return response;
}

export {
    generarCertificadosSIIIndividual,
    generarCertificadosSIIMasivo
}